import { createSlice } from "@reduxjs/toolkit";

const leftMenuVisibilitySlice = createSlice({
  name: "visibilityLeftMenu",
  initialState: {
    isOpenMenu: true,
  },
  reducers: {
    setOpenMenu: (state) => {
      state.isOpenMenu = true;
    },
    setCloseMenu: (state) => {
      state.isOpenMenu = false;
    },
  },
});

export const { getMenu, setOpenMenu, setCloseMenu } = leftMenuVisibilitySlice.actions;

export default leftMenuVisibilitySlice.reducer;
